import React from 'react';
import {
    IconButton,
    Box,
    useTheme,
    Button,
    Chip,
    Divider,
    Tooltip,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CustomTypography from 'components/Fileds/CustomTypography';
import IOSSwitch from 'components/Fileds/IOSSwitch';
import RoomServiceIcon from '@mui/icons-material/RoomService';
import GroupsIcon from '@mui/icons-material/Groups';

const StationCard = ({
    title,
    itemCount,
    description,
    enabled,
    onEdit,
    onDelete,
    onToggle,
    loading = false,
    toggleDisabled = false,
    isSwitch = true,
    isCount = false,
    handleAssignChefs
}) => {
    const theme = useTheme();
    return (
        // <Box className='d-flex align-items-center justify-content-between' sx={{ height: '100%', borderRadius: '5px', border: '1px solid #CBCBCB', padding: 1.5 }}>
        //     <Box>
        //         <CustomTypography
        //             variant={"h6"}
        //             label={title}
        //             sx={{ color: theme.palette.typographyLabel.main, fontSize: '16px', fontWeight: 600, mb: 0.5 }}
        //         />
        //         {itemCount?.toString() && <CustomTypography
        //             variant={"body2"}
        //             label={`${itemCount} ${isCount ? 'Chefs' : 'Food Items'}`}
        //             sx={{ color: theme.palette.typographyLabel.main, fontSize: '14px', fontWeight: 300, mb: 0 }}
        //         />}
        //         {description && <CustomTypography
        //             variant={"body2"}
        //             label={description}
        //             sx={{
        //                 color: theme.palette.typographyLabel.main, fontSize: '14px', fontWeight: 300, mb: 0,
        //                 maxWidth: '250px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'
        //             }}
        //         />}

        //     </Box>
        //     <Box>
        //         <Box sx={{ textAlign: 'right', mb: 1 }}>
        //             <IconButton onClick={onEdit} size="small">
        //                 <EditIcon fontSize="small" sx={{ color: '#1297DE' }} />
        //             </IconButton>
        //             <IconButton onClick={onDelete} size="small">
        //                 <DeleteIcon fontSize="small" sx={{ color: '#FF0202', mr: 0.5 }} />
        //             </IconButton>
        //             {isSwitch && <IOSSwitch checked={enabled} onChange={onToggle} disabled={toggleDisabled} />}
        //         </Box>
        //         <Box>
        //             <Button variant="outlined" size="small" sx={{ textTransform: 'none' }}
        //                 onClick={handleAssignChefs}
        //             >Assign Chefs</Button>
        //         </Box>
        //     </Box>
        // </Box>

        <Box
            sx={{
                height: '100%',
                borderRadius: '16px',
                border: '1px solid #E5E5E5',
                p: 2,
                backgroundColor: '#fff',
            }}
        >
            {/* Top Section */}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    minHeight: '70px', // keeps bottom section at same position
                }}
            >
                <Box sx={{ display: 'flex', gap: 1.5 }}>
                    <Box
                        sx={{
                            width: 40,
                            height: 40,
                            borderRadius: '10px',
                            backgroundColor: '#00000014',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        {/* Station Icon */}
                        <RoomServiceIcon fontSize="small" />
                    </Box>

                    <Box>
                        <CustomTypography
                            variant={"h6"}
                            label={title}
                            sx={{ color: theme.palette.typographyLabel.main, fontSize: '16px', fontWeight: 700, mb: 0.5 }}
                        />
                        {itemCount?.toString() &&
                            <CustomTypography
                                variant={"body2"}
                                label={`${itemCount} ${isCount ? 'Chefs' : 'Food Items'}`}
                                sx={{ color: theme.palette.text.secondary, fontSize: '12px', fontWeight: 500 }}
                            />
                        }
                        {description &&
                            <Tooltip
                                title={description}
                                placement="bottom"
                                arrow
                            >
                                <Box
                                    // ref={textRef}
                                    // onMouseEnter={checkOverflow}
                                    sx={{
                                        width: '100%',
                                        minWidth: 0,
                                        maxWidth: { xs: '200px', sm: "210px", md: "250px" },
                                        display: 'block',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        cursor: 'pointer',
                                    }}
                                >
                                    {/* <CustomTypography
                                        variant={"body2"}
                                        label={description}
                                        sx={{
                                            color: theme.palette.typographyLabel.main, fontSize: '14px', fontWeight: 300, mb: 0,
                                            maxWidth: '250px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'
                                        }}
                                    /> */}

                                    <CustomTypography
                                        component="div"
                                        label={description}
                                        sx={{
                                            color: theme.palette.typographyLabel.main, fontSize: '13px', fontWeight: 300, mb: 0,
                                            maxWidth: '250px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                                        }}
                                    />
                                </Box>
                            </Tooltip>
                        }
                    </Box>
                </Box>

                <Chip
                    label="Kitchen"
                    size="small"
                    sx={{
                        backgroundColor: '#00000014',
                        fontSize: '12px',
                        fontWeight: 600,
                        borderRadius: '20px',
                    }}
                />
            </Box>

            {/* Divider */}
            <Divider sx={{ my: 1, borderStyle: 'dashed', }} />

            {/* Bottom Section */}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mt: 1.5
                }}
            >
                <Button
                    variant="outlined"
                    size="small"
                    onClick={handleAssignChefs}
                    startIcon={<GroupsIcon />}
                    sx={{
                        textTransform: 'none',
                        borderRadius: '10px',
                        fontWeight: 600,
                    }}
                >
                    Assign Chefs
                </Button>

                <Box>
                    <IconButton
                        onClick={onEdit}
                        size="small"
                        sx={{
                            backgroundColor: '#EAF7FF',
                            mr: 1,
                        }}
                    >
                        <EditIcon sx={{ color: '#1297DE', fontSize: 18 }} />
                    </IconButton>

                    <IconButton
                        onClick={onDelete}
                        size="small"
                        sx={{
                            backgroundColor: '#FFF1F1',
                        }}
                    >
                        <DeleteIcon sx={{ color: '#FF4D4F', fontSize: 18 }} />
                    </IconButton>
                </Box>
            </Box>
        </Box>
    );
};

export default StationCard;
